"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Textfield = void 0;
var estiloTextfield = require('./Textfield.module.scss');
var react_1 = __importDefault(require("react"));
var Cores_1 = require("../../Cores/Cores");
var Icone_1 = require("../../Icone/Icone");
var HelperText_1 = require("../../HelperText/HelperText");
var Label_1 = require("../../Label/Label");
var globalMu_1 = __importDefault(require("../../../globalMu"));
var Textfield = function (_a) {
    var _b;
    var id = _a.id, name = _a.name, valor = _a.valor, titulo = _a.titulo, _c = _a.placeholder, placeholder = _c === void 0 ? "Placeholder..." : _c, _d = _a.variante, variante = _d === void 0 ? 'regular' : _d, _e = _a.tamanho, tamanho = _e === void 0 ? 'medium' : _e, posicaoIcone = _a.posicaoIcone, conteudoDeAjuda = _a.conteudoDeAjuda, autoCompletar = _a.autoCompletar, tipoDeEntrada = _a.tipoDeEntrada, _f = _a.iconeInputField, iconeInputField = _f === void 0 ? 'search' : _f, _g = _a.desabilitado, desabilitado = _g === void 0 ? false : _g, _h = _a.senha, senha = _h === void 0 ? false : _h, botaoDeLimpar = _a.botaoDeLimpar, _j = _a.readonly, readonly = _j === void 0 ? false : _j, _k = _a.autofocus, autofocus = _k === void 0 ? false : _k, maxLength = _a.maxLength, style = _a.style, onHover = _a.onHover, onChange = _a.onChange, onBlur = _a.onBlur, onKeyUp = _a.onKeyUp, onKeyDown = _a.onKeyDown, onFocus = _a.onFocus, onSubmit = _a.onSubmit, onBeforeInput = _a.onBeforeInput;
    var _l = react_1.default.useState(valor || null), inputValue = _l[0], setInputValue = _l[1];
    var _m = react_1.default.useState(Cores_1.Cores.GradacaoNeutros.CinzaFillMU600), cor = _m[0], setCor = _m[1];
    var _o = react_1.default.useState('20px'), iconSize = _o[0], setIconSize = _o[1];
    var iconPositionStyle = estiloTextfield[posicaoIcone || 'right'] || '';
    var disabledStyle = estiloTextfield.disabled || '';
    var varianteStyle = estiloTextfield[variante] || '';
    var inputFieldSize = estiloTextfield[tamanho] || '';
    var inputfieldStyle = desabilitado ? disabledStyle : varianteStyle;
    var limparCampo = function () {
        setInputValue(null);
        onChange && onChange(null);
    };
    var handleChange = function (event) {
        onChange && onChange(event.target.value);
        setInputValue(event.target.value);
    };
    react_1.default.useEffect(function () {
        setInputValue(valor !== null && valor !== void 0 ? valor : '');
    }, [valor]);
    react_1.default.useEffect(function () {
        switch (tamanho) {
            case 'small':
                setIconSize('16px');
                break;
            case 'medium':
                setIconSize('20px');
                break;
        }
    }, [tamanho]);
    react_1.default.useEffect(function () {
        desabilitado && setCor(Cores_1.Cores.GradacaoNeutros.CinzaFillMU400);
        if (!desabilitado) {
            switch (variante) {
                case 'success':
                    setCor(Cores_1.Cores.MensagensDoSistema.VerdeMU);
                    break;
                case 'error':
                    setCor(Cores_1.Cores.MensagensDoSistema.VermelhoMU);
                    break;
                case "regular":
                    setCor(Cores_1.Cores.GradacaoNeutros.CinzaFillMU600);
                    break;
            }
        }
    }, [variante, desabilitado]);
    var BotaoIcone = (react_1.default.createElement("div", { onClick: function () { return onSubmit && onSubmit(inputValue ? inputValue : null); }, onMouseEnter: function () { return onHover && onHover(); }, className: "".concat(estiloTextfield.searchBarIconButton, " ").concat(inputFieldSize, " ").concat(varianteStyle, " ").concat(desabilitado ? disabledStyle : '') }, iconeInputField && react_1.default.createElement(Icone_1.Icone, { nome: iconeInputField, cor: cor, corOnHover: variante === 'regular' && !desabilitado ? Cores_1.Cores.GradacaoPrimaria.AzulMU500 : undefined, largura: iconSize, altura: iconSize })));
    var BotaoLimpar = (react_1.default.createElement("div", { onClick: function () { return limparCampo(); }, className: "".concat(estiloTextfield.searchBarIconButton, " ").concat(inputFieldSize, " ").concat(varianteStyle, " ").concat(desabilitado ? disabledStyle : '') },
        react_1.default.createElement(Icone_1.Icone, { nome: 'close', largura: iconSize, altura: iconSize, desabilitado: desabilitado, cor: cor, corOnHover: Cores_1.Cores.MensagensDoSistema.VermelhoMU })));
    var Textfield = (react_1.default.createElement("div", { className: "\n            ".concat(estiloTextfield.searchBar, " \n            ").concat(iconPositionStyle, " \n            ").concat(inputFieldSize, "\n            ").concat(inputfieldStyle, "\n        ") },
        posicaoIcone === 'left' && BotaoIcone,
        react_1.default.createElement("input", { className: "".concat(estiloTextfield.inputField, " ").concat(inputFieldSize), autoComplete: autoCompletar, inputMode: tipoDeEntrada, onBeforeInput: function (e) {
                if (onBeforeInput)
                    onBeforeInput(e);
            }, onChange: handleChange, onKeyDown: function (e) {
                if (onKeyDown)
                    onKeyDown(e);
                if (e.key === 'Enter' && onSubmit)
                    onSubmit(inputValue);
            }, onBlur: function (e) {
                if (onBlur)
                    onBlur(e);
            }, disabled: desabilitado ? true : false, placeholder: placeholder, type: senha ? 'password' : 'text', name: name, id: id, maxLength: maxLength, readOnly: readonly, autoFocus: autofocus, value: inputValue !== null ? inputValue : '', onKeyUp: onKeyUp, onFocus: onFocus }),
        botaoDeLimpar && !globalMu_1.default.isNullOrEmpty(inputValue) && BotaoLimpar,
        posicaoIcone === 'right' && BotaoIcone));
    var Titulo = (react_1.default.createElement(Label_1.Label, { texto: titulo, negrito: 700, estado: variante, desabilitado: true, htmlFor: "", obrigatorio: false }));
    var ConteudoAjuda = (react_1.default.createElement(HelperText_1.HelperText, { texto: (conteudoDeAjuda === null || conteudoDeAjuda === void 0 ? void 0 : conteudoDeAjuda.texto) || '', desabilitado: desabilitado, estado: (_b = conteudoDeAjuda === null || conteudoDeAjuda === void 0 ? void 0 : conteudoDeAjuda.estado) !== null && _b !== void 0 ? _b : varianteStyle, icone: conteudoDeAjuda === null || conteudoDeAjuda === void 0 ? void 0 : conteudoDeAjuda.icone }));
    var estiloPredefinido = titulo || conteudoDeAjuda ? { gap: '8px' } : {};
    return (react_1.default.createElement("div", { className: estiloTextfield.container, style: __assign(__assign({}, estiloPredefinido), style) },
        titulo && Titulo,
        Textfield,
        conteudoDeAjuda && ConteudoAjuda));
};
exports.Textfield = Textfield;
